import styled from '@emotion/styled'
import React from 'react'

import ColorCircle from '../ColorCircle'
import { TickIcon } from 'components/icons'
import { formControlReset } from 'styles/reset'

const Wrapper = styled.div`
	position: relative;
`

const HiddenInput = styled.input`
	${formControlReset};
	position: absolute;
	top: 0;
	left: 0;

	& + label > svg {
		visibility: hidden;
	}

	&:checked + label > svg {
		visibility: visible;
	}

	&:focus-visible + label {
		outline: 1px solid ${({ theme }) => theme.colors.light.accent};
		outline-offset: 2px;
	}
`

type Props = JSX.IntrinsicElements['input']

const ColorRadio = React.forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
	const id = React.useId()
	return (
		<Wrapper>
			<HiddenInput id={id} type="radio" {...props} ref={ref} />
			<ColorCircle htmlFor={id} fill={props.value as string}>
				<TickIcon />
			</ColorCircle>
		</Wrapper>
	)
})

ColorRadio.displayName = 'ColorRadio'

export default ColorRadio
